import { memo } from 'react';

import type { Theme } from '@mui/material';
import { styled } from '@mui/styles';

type TSideShadowProps = {
  side: 'top' | 'right' | 'bottom' | 'left';
  value:
    | number
    | {
        offset: number;
        blur: number;
        color: string;
      };
};

const parseValue = (shadow: string) => {
  const parsed = /\dpx (\d)px (\d)px (.+)/.exec(shadow) || [null, 0, 0, ''];

  return { offset: Number(parsed[1]), blur: Number(parsed[2]), color: parsed[3] };
};

const SideShadowComponent = styled('div')<Theme, TSideShadowProps>(({ side, value, theme }) => {
  const { offset, blur, color } =
    typeof value === 'number' ? parseValue(theme.shadows[value]) : value;

  return {
    position: 'absolute',
    height: blur / 2 + offset,
    top: side === 'bottom' ? '100%' : 0,
    left: side === 'right' ? '100%' : 0,
    right: side === 'left' ? '100%' : 0,
    bottom: side === 'top' ? '100%' : 0,
    background: `linear-gradient(to ${side}, ${color} ${offset - blur / 2}px, transparent 100%)`,
    pointerEvents: 'none',

    ...{ [side]: 'auto' },
  };
});

export const SideShadow = memo(SideShadowComponent);
